module.exports = function arrayObjectExcept(excepts = []) {
  let newData = [];

  for (let item of this.items) {
    const collect = new this.constructor(item);
    newData.push(collect.except(excepts).all());
  }

  return new this.constructor(newData);
};
